<section id="testimonials" class="testimonials testimonials--light">
  <div class="testimonials__container">
    
    <div class="testimonials__header" appScrollAnimate [animationDelay]="0" [threshold]="0.3">
      <p class="testimonials__subtitle">TESTIMONIALS</p>
      <h2 class="testimonials__title">Client Reviews</h2>
      <div class="testimonials__divider"></div>
    </div>

    <div class="testimonials__widget-container" appScrollAnimate [animationDelay]="200" [threshold]="0.2">
      <div class="elfsight-app-0183792f-7b88-41f6-ae2c-0881060af1d5" data-elfsight-app-lazy></div>
    </div>

  </div>
</section>